import {ProjectedPerformance} from 'src/app/shared/models/ProjectedPerformance.model';
import {LenderInformation} from 'src/app/shared/models/LenderInformation.model';
import {ProjectBudget} from 'src/app/shared/models/ProjectBudget.model';
import {CurrencyModel} from 'src/app/shared/models/CurrencyModel';
import FundInvestmentStrategyType from 'src/app/shared/enums/FundInvestmentStrategyType.enum';
import {HoldingFileReqRes} from 'src/app/dashboard/shared/holding/HoldingFileReqRes.model';
import {GpAssetListItemReqRes} from '../assets/GpAssetReqRes.model';
import {InvestingEntityReqRes} from '../models/InvestingEntityReqRes.model';
import {GpHoldingListItemReqRes} from '../shared/holding/GpHoldingListItem.model';
import {GpHolding} from '../shared/holding/GpHolding.model';
import { CommitmentsEnabled } from 'src/app/shared/enums/CommitmentsEnabled.enum';
import { OwnershipCalculationType } from 'src/app/shared/enums/OwnershipCalculationType.enum';
import { LpOwnershipVisibility } from 'src/app/shared/enums/LpOwnershipVisibility.enum';

export class GpFundListItemReqRes extends GpHoldingListItemReqRes {
  public email: string;
  public isCollectDeposists: boolean;
  public canSetAsPrivate: boolean;
  public attachments: HoldingFileReqRes[];

  // Front only property:
  public isExampleAsset = false;

  public percentsFunded: number;
  public fundraisingTargetAmount: number;
  public initialCurrency: CurrencyModel;
  public estimatedClosingDate: Date;
  public investingEntityId: number;
}

export class GpFundReqRes extends GpHolding {
  public isCollectDeposists: boolean;
  public canSetAsPrivate: boolean;

  // Front only property:
  public isExampleAsset = false;

  public investmentStrategyType: FundInvestmentStrategyType;
  public investmentStrategyTypeOther: string;

  public projectedPerformance: ProjectedPerformance;
  public lenderInformation: LenderInformation;

  public projectBudgetOriginal: ProjectBudget;
  public projectBudgetUpdated: ProjectBudget;

  // #region Cumulative information:
  public plannedCostsToDate: number;
  public actualCostsToDate: number;

  public gpEquityFromTotalEquity: number;
  public estimatedMarketValue: number;

  public cumulativeProjectedPerformance: ProjectedPerformance;
  // #endregion

  public initialCurrency: CurrencyModel;
  public initialCurrencyId: number;
  public assets: GpAssetListItemReqRes[];
  public investingEntity: InvestingEntityReqRes;
  public relatedHoldings: GpHoldingListItemReqRes[];

  public commitmentsEnabled: CommitmentsEnabled;
  public ownershipCalculationType: OwnershipCalculationType;
  public lpOwnershipVisibility: LpOwnershipVisibility;
  public displayCommitments: boolean;
}
